<template>
  <div style="margin-bottom: 24px">
    <h4>Загрузка файлов</h4>
    <ul class="help_upload">
      <li>Выберите файлы для загрузки и нажмите загрузить файлы.</li>
      <li>Дождитесь пока загружаемые файлы появятся в списке ниже</li>
    </ul>
    <el-upload
      ref="upload"
      multiple
      :file-list="fileList"
      :http-request="customUpload"
      :before-upload="beforeUpload"
      action=""
      :auto-upload="false"
    >
      <el-button
        slot="trigger"
        size="small"
        type="primary"
        style="width: 210px"
      >
        Выберите файлы для загрузки
      </el-button>
      <el-button
        v-if="!isMobile"
        size="small"
        type="success"
        style="margin-left: 10px"
        @click="submitUpload"
      >
        Загрузить файлы
      </el-button>
      <p v-if="isMobile">
        <el-button
          size="small"
          type="success"
          style="width: 210px"
          @click="submitUpload"
        >
          Загрузить файлы
        </el-button>
      </p>
      <div slot="tip" class="el-upload__tip">
        jpg/png и pdf файлы. Размер загружаемого документа не более 10 мб
      </div>
      <el-progress
        v-if="uploadPercentage > 0 && uploadPercentage < 100"
        :percentage="uploadPercentage"
      />
    </el-upload>
  </div>
</template>

<script>
import { RepositoryFactory } from '@/api/RepositoryFactory'

const FileRepository = RepositoryFactory.get('file')

export default {
  name: 'NewUploadFiles',
  props: {
    docunentId: {
      type: Number,
      default: 0,
    },
    pastedFile: {
      type: File,
      default: undefined,
    },
  },
  data() {
    return {
      fileList: [],
      uploadParams: {
        docunentId: 0,
      },
      uploadPercentage: 0,
    }
  },
  watch: {
    docunentId: {
      immediate: true,
      handler(newVal) {
        this.uploadParams.docunentId = newVal
      },
    },
    pastedFile(value) {
      if (value) {
        this.uploadFromBuffer(value)
      }
    },
  },
  methods: {
    submitUpload() {
      this.$refs.upload.submit()
    },
    customUpload(file) {
      let param = new FormData()

      param.append('file_path', file.file)
      param.append('document_id', this.docunentId)
      this.$emit('uploadImages', param, this)
      this.fileList = []
    },

    beforeUpload(file) {
      const isFormat =
        file.type === 'image/jpeg' ||
        file.type === 'image/png' ||
        file.type === 'application/pdf'
      const isSize = file.size / 1024 / 1024 < 10

      if (!isFormat) {
        this.$alert(
          'Ошибка при загрузке файла ' +
            file.name +
            ' попробуйте еще раз. Неверный формат',
        )
      }
      if (!isSize) {
        this.$alert(
          'Ошибка при загрузке файла ' +
            file.name +
            ' попробуйте еще раз. Превышен размер',
        )
      }

      return isFormat && isSize
    },
    uploadFromBuffer(file) {
      const param = new FormData()

      param.append('file_path', file)
      param.append('document_id', this.docunentId)
      this.$emit('startUpload')
      FileRepository.upload(param, this)
        .then(response => {
          if (response.data.id === undefined) {
            this.$alert('Ошибка при загрузке попробуйте еще раз. Ошибка #B') // TODO Как убрать из списка файлов если не загрузили
          }
          if (response.data.id !== undefined) {
            if (this.uploadPercentage === 100) {
              setTimeout(() => {
                this.uploadPercentage = 0
              }, 10000)
            }
            this.$emit('uploaded', response.data)
          }
          this.fileList = []
        })
        .catch(err => {
          // eslint-disable-next-line
            console.log(`error upload: `, err)
          const data = err ? err.data : null
          let message = 'Произошла ошибка!'

          if (
            data &&
            data.errors &&
            data.errors.file_path &&
            data.errors.file_path.length
          ) {
            message = data.errors.file_path[0]
          }
          this.$message({
            message,
            type: 'error',
            duration: 0,
            showClose: true,
          })
          setTimeout(() => {
            this.uploadPercentage = 0
            this.$emit('aborted')
          }, 2500)
        })

      return false
    },
  },
}
</script>

<style scoped></style>
